import React, { useState } from 'react';
import { Button, Container, Row, Col, Form} from 'react-bootstrap';
import Design from '../components/PortfolioDesign';
import portfolioData from '../components/PortfolioData'; // Assuming this is your data file
import '../App.css'
import {Link} from "react-router-dom";


const Portfolio = () => {
    const [selectedCategory, setSelectedCategory] = useState('Logo');
    const [searchTerm, setSearchTerm] = useState('');

    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
    };

    const renderDesigns = () => {
        let filteredDesigns = portfolioData[selectedCategory] || [];

        if (searchTerm) {
            filteredDesigns = filteredDesigns.filter(design =>
                design.title.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        return filteredDesigns.map((design, index) => (
            <Col key={index} sm={12} md={12} lg={12}>
                <Design {...design} />
            </Col>
        ));
    };

    return (
        <Container className="py-4">
            <Form className="mb-3">
                <Form.Group>
                    <Form.Control
                        type="text"
                        placeholder="Search designs..."
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </Form.Group>
            </Form>
            <div className="mb-3 mr-4">
                {Object.keys(portfolioData).map((category, index) => (
                    <Button
                        key={index}
                        variant={selectedCategory === category ? 'success' : 'secondary'}
                        onClick={() => handleCategoryClick(category)}
                        className="me-2 mb-2"
                    >
                        {category}
                    </Button>
                ))}
            </div>
            <Row>
                {renderDesigns()}
            </Row>
            <div className="d-flex justify-content-center align-items-center mt-4">

                <Button variant="success" className="meet-team-button" >
                    <Link to="https://www.behance.net/"  className="link-text">View More</Link>
                </Button>
            </div>

        </Container>
    );
};

export default Portfolio;
